import fetch from "../utils/fetch";
//添加店铺
export const fetchAddShop = (body) =>
  fetch(`/shop`, {
    method: "post",
    body,
  });

//店铺列表
export const fetchShopList = (companyId) =>
  fetch(`/shop?companyId=${companyId}`);

//编辑店铺
export const fetchEditShop = (body) =>
  fetch(`/shop`, {
    method: "put",
    body,
  });
//删除店铺
export const fetchDeleteShop = (id) =>
  fetch(`/shop/${id}`, {
    method: "delete",
  });
